// extracted by mini-css-extract-plugin
module.exports = {"anonymousLogin":"SendBox_anonymousLogin__2JIog","anonymousEmoji":"SendBox_anonymousEmoji__1N2Cc"};